/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=template&id=105fceb1&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-table-pager",class:`sf-table-pager--${_vm.backgroundColor}`},[_c('button',{staticClass:"sf-table-pager__btn sf-table-pager__btn--prev",attrs:{"title":_vm.$t('prevLabel'),"aria-label":_vm.$t('prevLabel'),"type":"button","disabled":_vm.isPrevDisabled},on:{"click":_vm.handleMoveToPrev}},[_c('span',{staticClass:"sr-only"},[_vm._t("prev-label",function(){return [_vm._v(_vm._s(_vm.$t('prevLabel')))]})],2)]),_c('div',{staticClass:"sf-table-pager__heading",attrs:{"aria-live":"polite","aria-atomic":"true"}},[_vm._l((_vm.columns),function(column,index){return [(_vm.activeColumn == column)?[_vm._t(column)]:_vm._e()]})],2),_c('button',{staticClass:"sf-table-pager__btn sf-table-pager__btn--next",attrs:{"title":_vm.$t('nextLabel'),"aria-label":_vm.$t('nextLabel'),"type":"button","disabled":_vm.isNextDisabled},on:{"click":_vm.handleMoveToNext}},[_c('span',{staticClass:"sr-only"},[_vm._t("next-label",function(){return [_vm._v(_vm._s(_vm.$t('nextLabel')))]})],2)])])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/VueTablePager.lang.json
const VueTablePager_lang_namespaceObject = JSON.parse('{"en":{"prevLabel":"Previous Item","nextLabel":"Next Item"},"hu":{"prevLabel":"Previous Item","nextLabel":"Next Item"}}');
;// CONCATENATED MODULE: ./src/components/constants.js
const BGCOLOR = {
	GRAY: 'gray',
	WHITE: 'white'
};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=script&lang=js&




/* harmony default export */ const VueTablePagervue_type_script_lang_js_ = ({
	name: 'VueTablePager',
	data: () => ({
		columns: [],
		currentColumn: 0,
		activeColumn: null
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Sets the background color
		 * @values gray, white
		 */
		backgroundColor: {
			type: String,
			required: false,
			default: BGCOLOR.GRAY,
			validator(val) {
				return Object.values(BGCOLOR).includes(val);
			}
		}
	},
	i18n: { messages: VueTablePager_lang_namespaceObject },
	watch: {
		activeColumn(val) {
			this.$emit('input', val);
		},
		value: {
			handler(val) {
				if (val) {
					this.activeColumn = val;
				} else {
					if (this.columns && this.columns.length) {
						this.activeColumn = this.columns[0];
					}
				}
			},
			immediate: true
		},
		columns(val) {
			if (val && val.length && this.activeColumn == null) {
				this.activeColumn = this.columns[0];
			}
		}
	},
	methods: {
		handleMoveToPrev() {
			if (!this.isPrevDisabled) {
				this.activeColumn = this.columns[this.indexOfActiveColumn - 1];
			}
		},
		handleMoveToNext() {
			if (!this.isNextDisabled) {
				this.activeColumn = this.columns[this.indexOfActiveColumn + 1];
			}
		}
	},
	computed: {
		numberOfColumns() {
			return this.columns.length;
		},
		indexOfActiveColumn() {
			return this.columns.indexOf(this.activeColumn);
		},
		isPrevDisabled() {
			return !this.indexOfActiveColumn;
		},
		isNextDisabled() {
			return this.indexOfActiveColumn + 1 == this.numberOfColumns;
		}
	},
	mounted() {
		this.columns = Object.keys(this.$slots);
	}
});

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueTablePagervue_type_script_lang_js_ = (VueTablePagervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-18.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-18.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-18.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-18.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueTablePager.vue?vue&type=style&index=0&id=105fceb1&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue?vue&type=style&index=0&id=105fceb1&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueTablePager.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueTablePagervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "105fceb1",
  null
  
)

/* harmony default export */ const VueTablePager = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueTablePager);


module.exports = __webpack_exports__["default"];
/******/ })()
;
//# sourceMappingURL=vue-table-pager.common.js.map